<div *ngIf="member">
  <img *ngIf="member.image; else noImageTemplate" [src]="member.image" alt="{{ getInitials(member.name) }}"
    class="rounded-full border border-white z-10" [ngClass]="config.size" />
  <ng-template #noImageTemplate>
    <div class="rounded-full flex justify-center items-center border-2 border-white text-white text-md uppercase"
      [ngClass]="config.size || 'w-8 h-8'" [style.background-color]="member.settings?.avatarBgColor || defaultColor">
      {{ getInitials(member.name + ' ' + member.lastName) }}
    </div>
  </ng-template>
</div>
